import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';

const FieldFirstName = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'settings-form-firstName',
    defaultMessage: 'First name'
  });
  const [field, meta] = useField({name: 'firstName'});

  return (
    <InputText
      {...field}
      {...meta}
      variant={'full'}
      id={field.name}
      label={labelText}
      defaultValue={field.value}
      disabled={true}
    />
  );
};

export default FieldFirstName;
